export default "__VITE_ASSET__DEXwvWn$__"